export default __webpack_public_path__ + "static/media/green_check.3298f5fd.svg";